const portuguese = {
  weekdays: {
    shorthand: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    longhand: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']
  },
  months: {
    shorthand: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    longhand: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
  },
  firstDayOfWeek: 1,
  rangeSeparator: ' - ',
  scrollTitle: 'Deslize para aumentar',
  toggleTitle: 'Clique para alternar',
  yearAriaLabel: 'Ano',
  monthAriaLabel: 'Mês',
  time_24hr: true
};

const locales = {
  es: {
    weekdays: {
      shorthand: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      longhand: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
    },
    months: {
      shorthand: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      longhand: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    },
    firstDayOfWeek: 1,
    rangeSeparator: ' - ',
    scrollTitle: 'Desplázate para aumentar',
    toggleTitle: 'Haz clic para cambiar',
    yearAriaLabel: 'Año',
    monthAriaLabel: 'Mes',
    time_24hr: true
  },
  pt: portuguese,
  br: { ...portuguese, firstDayOfWeek: 0 }
};

export const getCalendarLocale = (language) => language === 'ru' ? 'ru' : locales[language] || 'default';
